(function () {
  'use strict';

  angular
    .module('adminCrewBatchers')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('adminCrewBatchers', {
          sticky: true,
          url: '/admin-crew-batchers',
          views: {
              'adminCrewBatchersView': {
                  templateUrl: 'admin-crew-batchers/views/admin-crew-batchers.tpl.html',
                  controller: 'AdminCrewBatchersCtrl',
                  controllerAs: 'adminCrewBatchers'
              }
          }
      });
  }
}());
